export default __webpack_public_path__ + "static/media/central_andes_1_1.fbd05c71.JPG";